export default "__VITE_ASSET__qLOO0Dcr__"